// src/hooks/useRevueFnct.ts — SCE Issues
// La dernière revue des FNC-T (lot 3 du § 14, 22/10), lue une fois par session
// et diffusée : l'onglet Revue et la carte de l'accueil disent la même date, et
// « Marquer la revue faite » met les deux à jour sans rechargement.

import { useCallback, useEffect, useState } from 'react'
import { lireRevuesFnct, marquerRevueFaite } from '@/api/revueFnct.api'
import type { RevueFaite } from '@/utils/revueFnct'

const EVENEMENT = 'sce:revue-fnct-marquee'
let enMemoire: Promise<RevueFaite[]> | null = null

export function useRevueFnct(actif = true): {
  derniere: RevueFaite | null
  lue: boolean
  marquer: (par: string) => Promise<void>
} {
  const [revues, setRevues] = useState<RevueFaite[]>([])
  const [lue, setLue] = useState(false)

  useEffect(() => {
    if (!actif) return undefined
    let encore = true
    enMemoire ??= lireRevuesFnct().catch((err: unknown) => {
      enMemoire = null
      throw err
    })
    enMemoire
      .then((r) => {
        if (encore) setRevues(r)
      })
      .catch((err: unknown) => {
        // eslint-disable-next-line no-console
        console.warn('[useRevueFnct] lecture impossible:', err)
      })
      .finally(() => {
        if (encore) setLue(true)
      })
    const ecouter = (e: Event): void => setRevues((e as CustomEvent<RevueFaite[]>).detail)
    window.addEventListener(EVENEMENT, ecouter)
    return () => {
      encore = false
      window.removeEventListener(EVENEMENT, ecouter)
    }
  }, [actif])

  const marquer = useCallback(async (par: string): Promise<void> => {
    const r = await marquerRevueFaite(par)
    enMemoire = Promise.resolve(r)
    window.dispatchEvent(new CustomEvent<RevueFaite[]>(EVENEMENT, { detail: r }))
  }, [])

  return { derniere: revues.at(-1) ?? null, lue, marquer }
}
